import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { LocalCacheService } from '../../services/local-cache.service';
import { LocalCacheModel } from './../../models/local-cache.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-welcome-aboard',
  templateUrl: './welcome-aboard.component.html',
  styleUrls: ['./welcome-aboard.component.scss'],
})
export class WelcomeAboardComponent implements OnInit, OnDestroy {
  relihUrl = environment.relihUrl;
  habitatUrl = environment.habitatUrl;

  currentLanguage = '';
  subscription = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<WelcomeAboardComponent>,
    private localCacheService: LocalCacheService,
    private translateService: TranslateService
  ) {
    this.currentLanguage = this.translateService.currentLang;
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.translateService.onLangChange.subscribe((x) => {
        this.currentLanguage = this.translateService.currentLang;
      })
    );
  }

  closeDialog() {
    if (this.dialogRef) {
      this.dialogRef.close();

      const welcomeAboard = new LocalCacheModel('welcome-aboard', 'true');
      this.localCacheService.set(welcomeAboard);
    }
  }
}
